import { create } from 'zustand'
import authService from '../services/authService'
import { clearPermissionCache } from '../hooks/usePermissions'

export const useAuthStore = create((set, get) => ({
  // State
  user: authService.getStoredUser(),
  isAuthenticated: authService.isAuthenticated(),
  isLoading: false,
  error: null,

  // Actions
  login: async (credentials) => {
    set({ isLoading: true, error: null })

    try {
      const response = await authService.login(credentials)

      if (response.status === 'success') {
        const { access_token, refresh_token, user } = response.data

        // Store tokens and user
        authService.setTokens(access_token, refresh_token)
        authService.setUser(user)

        // Clear permission cache to force re-fetch with new user
        clearPermissionCache()

        set({
          user,
          isAuthenticated: true,
          isLoading: false,
          error: null,
        })

        return { success: true }
      } else {
        throw new Error(response.message || 'Login failed')
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Login failed'
      set({ isLoading: false, error: message })
      return { success: false, error: message }
    }
  },

  logout: async () => {
    set({ isLoading: true })

    await authService.logout()

    // Clear permission cache when logout
    clearPermissionCache()

    set({
      user: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,
    })
  },

  refreshUser: async () => {
    try {
      const response = await authService.getMe()

      if (response.status === 'success') {
        authService.setUser(response.data)
        set({ user: response.data })
      }
    } catch (error) {
      // If failed to get user, logout
      get().logout()
    }
  },

  clearError: () => {
    set({ error: null })
  },
}))
